module.exports = __webpack_public_path__ + "img/@tmp_thumb01.e5a2ad22.jpg";